import { getAuthority } from './authority';

import RenderAuthorized from '.';

// eslint-disable-next-line import/no-mutable-exports
let Authorized = RenderAuthorized(getAuthority());

// 更新权限
const reloadAuthorized = () => {
  Authorized = RenderAuthorized(getAuthority());
};

export { reloadAuthorized };
export default Authorized;
